import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "teams-date-picker relative" }
const _hoisted_2 = { class: "flex h-full whitespace-nowrap text-normal" }
const _hoisted_3 = {
  key: 0,
  class: "font-semibold my-auto mr-1"
}
const _hoisted_4 = { class: "my-auto w-auto" }
const _hoisted_5 = { class: "h-full flex items-center my-auto ml-2" }

import { ChevronDown } from 'lucide-vue-next';
import { computed, ref } from 'vue';
import FlatPickrWrapper from '@/components/ui/FlatpickrWrapper.vue';
import { i18n } from '@/plugins/internationalization/i18n';

interface Props {
    prefix?: string;
    config?: Record<string, any>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TeamsDatePicker',
  props: /*@__PURE__*/_mergeModels({
    prefix: {},
    config: {}
  }, {
    "modelValue": { required: true },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const modelValue = _useModel<string>(__props, 'modelValue');

const displayValue = computed(() => i18n.global.d(new Date(Date.parse(modelValue.value)), 'short'));

const expanded = ref(false);

function onChange(newValue: string) {
    modelValue.value = newValue || new Date().toISOString();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FlatPickrWrapper, {
      show: expanded.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((expanded).value = $event)),
      value: modelValue.value,
      "auto-width": "",
      class: "h-full",
      "show-overlay": false,
      config: _ctx.config,
      "onUpdate:value": onChange
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: _normalizeClass([[expanded.value ? 'bg-white border-black' : 'bg-transparent border-gray-200', 'h-full py-2 px-3'], "text-left flex text-base text-dark-gray-600 content-center border-solid border rounded-md"]),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (expanded.value = !expanded.value), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.prefix)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.prefix) + ":", 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_4, _toDisplayString(displayValue.value), 1),
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_unref(ChevronDown), {
                class: _normalizeClass(["size-5 -mr-1 transform transition-transform", { 'rotate-[180deg]': expanded.value }])
              }, null, 8, ["class"])
            ])
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["show", "value", "config"])
  ]))
}
}

})